"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ContentRow = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useResizeCard2 = _interopRequireDefault(require("../../../hooks/useResizeCard"));

var _style = require("./style");

var _methods = require("../../../utils/methods");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ContentRow = function ContentRow(_ref) {
  var columnSections = _ref.columnSections,
      columnQuantity = _ref.columnQuantity,
      startDatetime = _ref.startDatetime,
      columnRangeType = _ref.columnRangeType,
      assemble = _ref.assemble;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      contentCards = _useState2[0],
      setContentCards = _useState2[1];

  var _useResizeCard = (0, _useResizeCard2["default"])({
    columnSections: columnSections,
    columnQuantity: columnQuantity,
    startDatetime: startDatetime,
    columnRangeType: columnRangeType
  }),
      totalTimeRow = _useResizeCard.totalTimeRow,
      calcTotalTime = _useResizeCard.calcTotalTime;

  var addContentCards = (0, _react.useCallback)(function () {
    var items = assemble.reduce(function (prev, current, index) {
      var begin = current.begin,
          end = current.end;
      var totalSecondsContent = (end - begin) / 1000;
      var rangeBegin = (begin - startDatetime) / 1000;
      var totalTimeContent = calcTotalTime(totalSecondsContent);
      var totalTimeBegin = calcTotalTime(rangeBegin);
      var totalWidthContent = (0, _methods.ruleThree)(totalTimeContent, totalTimeRow);
      var leftPositionContent = (0, _methods.ruleThree)(totalTimeBegin, totalTimeRow);
      console.log("=============");
      console.log("Begin: ".concat(begin, ", end: ").concat(end, ", rangeBegin: ").concat(rangeBegin, " "));
      console.log("totalTimeContent: ".concat(totalTimeContent, ", totalTimeBegin: ").concat(totalTimeBegin, ", rangeBegin: ").concat(rangeBegin, " "));
      console.log("totalWidthContent: ".concat(totalWidthContent, ", leftPositionContent: ").concat(leftPositionContent, " "));
      return [].concat(_toConsumableArray(prev), [_objectSpread(_objectSpread({}, current), {}, {
        totalSecondsContent: totalSecondsContent,
        totalTimeContent: totalTimeContent,
        totalTimeBegin: totalTimeBegin,
        totalTimeRow: totalTimeRow,
        rangeBegin: rangeBegin,
        width: "".concat(totalWidthContent, "%"),
        left: "".concat(leftPositionContent, "%"),
        zIndex: index + 100
      })]);
    }, []);
    setContentCards(items);
  }, [assemble, calcTotalTime, startDatetime, totalTimeRow]);
  (0, _react.useEffect)(function () {
    addContentCards();
  }, [addContentCards]);
  return /*#__PURE__*/_react["default"].createElement(_style.Wrapper, null, contentCards.map(function (_ref2) {
    var available = _ref2.available,
        status = _ref2.status,
        data = _ref2.data,
        icon = _ref2.icon,
        width = _ref2.width,
        left = _ref2.left,
        zIndex = _ref2.zIndex;
    return available ?
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    _react["default"].createElement(_style.ContentRowCardContainer, {
      zIndex: zIndex,
      width: width,
      left: left,
      key: zIndex
    }, /*#__PURE__*/_react["default"].createElement(_style.ContentRowCard, null, typeof status === 'boolean' && /*#__PURE__*/_react["default"].createElement(_style.ContentRowCardStatus, {
      style: {
        marginRight: '0.6rem'
      },
      status: status
    }), icon && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        paddingRight: '0.2rem'
      }
    }, icon), data)) : /*#__PURE__*/_react["default"].createElement(_style.ContentRowCardArrowWrapper, {
      width: width,
      left: left,
      key: zIndex
    }, data, /*#__PURE__*/_react["default"].createElement(_style.ContentRowArrowContainer, null, /*#__PURE__*/_react["default"].createElement(_style.ContentRowCardArrowBegin, null), /*#__PURE__*/_react["default"].createElement(_style.ContentRowCardArrow, null), /*#__PURE__*/_react["default"].createElement(_style.ContentRowCardArrowEnd, null)));
  }));
};

exports.ContentRow = ContentRow;
ContentRow.propTypes = {
  columnSections: _propTypes["default"].number,
  columnQuantity: _propTypes["default"].number,
  startDatetime: _propTypes["default"].instanceOf(Date),
  columnRangeType: _propTypes["default"].oneOf(['HOUR', 'DAY']),
  assemble: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    available: _propTypes["default"].bool,
    begin: _propTypes["default"].instanceOf(Date),
    end: _propTypes["default"].instanceOf(Date),
    data: _propTypes["default"].any,
    status: _propTypes["default"].bool,
    icon: _propTypes["default"].any
  }))
};
ContentRow.defaultProps = {
  columnSections: 8,
  columnQuantity: 7,
  startDatetime: new Date(),
  columnRangeType: 'DAY',
  assemble: []
};
var _default = ContentRow;
exports["default"] = _default;